define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min',
  'js/toastr/toastr'
], function ToastrModule(aoflModules, toastr) {
  'use strict';
  var storeService = aoflModules.store;
  /**
   * Handles Toastr alerts
   * @function ToastrService
   * @param {Object} riqToastrStateService - riqToastrStateService
   * @return {Object} ToastrService
   * */
  var ToastrService = function ToastrService(riqToastrStateService) {
    var toastrs = {};
    storeService.addState(riqToastrStateService);

    var defaultToastrOptions = {
      target: '#alerts',
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: false,
      positionClass: 'toast-top-full-width',
      preventDuplicates: true,
      onclick: null,
      showDuration: 500,
      hideDuration: 500,
      timeOut: 5000,
      extendedTimeOut: 1000,
      showEasing: 'swing',
      hideEasing: 'swing',
      showMethod: 'slideDown',
      hideMethod: 'slideUp',
      onHidden: onHideToastr
    };

    var defaultToastrErrorOptions = {
      timeOut: 5000,
      extendedTimeOut: 1000
    };

    function onHideToastr() {
      var storeData = storeService.getState();
      var namespace = riqToastrStateService.namespace;
      var toastrState = storeData[namespace];

      for (var i in toastrState) {
        if (toastrState[i]) {
          var toastrKey = i;
          var showToastr = toastrState[i].show;
          if (showToastr) {
            storeService.commit([
              {
                stateAlias: 'riqToastrs',
                mutationId: 'hide',
                payload: toastrKey
              }
            ]);
          }
        }
      }
    }

    var buildMessage = function buildMessage(
      _toastrKey,
      _type,
      _message,
      _title,
      _options
    ) {
      var type = _type || 'success';
      var message = _message || '';
      var title = _title || '';
      var options = _options || {};
      if (_type === 'error') {
        options = _options || defaultToastrErrorOptions;
      }
      options = Object.assign({}, defaultToastrOptions, options);
      return toastr[type](message, title, options);
    };

    var open = function open(toastrKey, type, message, title, options) {
      var toastrObj = toastrs[toastrKey];
      if (!toastrObj) {
        return;
      }
      toastrObj.type = type ? type : toastrObj.type;
      toastrObj.message = message ? message : toastrObj.message;
      toastrObj.title = title ? title : toastrObj.title;
      toastrObj.options = options ? options : toastrObj.options;

      return buildMessage(
        toastrKey,
        toastrObj.type,
        toastrObj.message,
        toastrObj.title,
        toastrObj.options
      );
    };

    var registerToastr = function registerToastr(toastrConfig) {
      for (var i in toastrConfig) {
        if (toastrConfig[i]) {
          toastrs[i] = toastrConfig[i];
          var toastrKey = i;
          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'register',
              payload: toastrKey
            }
          ]);
        }
      }
    };

    var renderToastrStates = function renderToastrStates() {
      var storeData = storeService.getState();
      var namespace = riqToastrStateService.namespace;

      var toastrState = storeData[namespace];
      for (var i in toastrState) {
        if (toastrState[i]) {
          var toastrKey = i;
          var showToastr = toastrState[i].show;
          var type = toastrState[i].type;
          var message = toastrState[i].message;
          var title = toastrState[i].title;
          var options = toastrState[i].options;

          if (showToastr) {
            open(toastrKey, type, message, title, options);
          }
        }
      }
    };

    storeService.subscribe(renderToastrStates);
    return {
      registerToastr: registerToastr
    };
  };

  return ToastrService;
});
